<template>
    <div class="py-4 container-fluid">
      <div class="card">
        <div class="card-header py-3">
          <div class="row">
            <div class="col-4">
              <IconField>
                <InputIcon>
                  <i class="pi pi-search" />
                </InputIcon>
                <InputText
                  v-model="table.search"
                  type="text"
                  size="small"
                  placeholder="Search"
                  class="rounded-pill w-100"
                  @keyup="filter"
                />
              </IconField>
            </div>
            <div class="col-4"></div>
          </div>
        </div>
        <DataTable :value="table.data" size="null" removable-sort scrollable scroll-height="450px" table-style="min-width: 50rem">
          <Column field="answer" header="Code" header-class="bg-light text-dark" sortable>
            <template v-if="table.onLoad" #body>
              <Skeleton></Skeleton>
            </template>
          </Column>
          <Column field="question" header="Characteristic" header-class="bg-light text-dark" sortable>
            <template v-if="table.onLoad" #body>
              <Skeleton></Skeleton>
            </template>
          </Column>
          <Column field="answer" header="char_sap" header-class="bg-light text-dark" sortable>
            <template v-if="table.onLoad" #body>
              <Skeleton></Skeleton>
            </template>
          </Column>
          <Column field="answer" header="Label" header-class="bg-light text-dark" sortable>
            <template v-if="table.onLoad" #body>
              <Skeleton></Skeleton>
            </template>
          </Column>
          <Column field="answer" header="Position" header-class="bg-light text-dark" sortable>
            <template v-if="table.onLoad" #body>
              <Skeleton></Skeleton>
            </template>
          </Column>
          <Column field="answer" header="Space" header-class="bg-light text-dark" sortable>
            <template v-if="table.onLoad" #body>
              <Skeleton></Skeleton>
            </template>
          </Column>
          <Column field="answer" header="single_or_multiple" header-class="bg-light text-dark" sortable>
            <template v-if="table.onLoad" #body>
              <Skeleton></Skeleton>
            </template>
          </Column>
          <Column field="created_at" header="Created at" header-class="bg-light text-dark" sortable>
            <template v-if="table.onLoad" #body>
              <Skeleton></Skeleton>
            </template>
          </Column>
        </DataTable>
        <div class="card-footer pb-0 d-flex justify-content-between align-items-center">
          <BasePagination
            v-model="table.page.current_pages"
            :page-count="table.page.total_pages"
            size="sm"
            @click="changePage()"
          />
          <p>
            {{ (table.page.current_pages - 1) * table.page.per_pages + table.data.length }}
            of {{ table.total }}
          </p>
        </div>
      </div>
    </div>
  </template>
  
  <script>
  import api from "@/helpers/api";
  import faqService from "@/services/faqService";
  
  export default {
    data() {
      return {
        loadTimeout: null,
        table: {
          onLoad: true,
          search: this.$route.query.search ? this.$route.query.search : "",
          total: 0,
          data: new Array(4),
          page: {
            current_pages: 1,
          },
          loadTimeout: null,
        },
        modal: {
          visible: false,
          action: "",
          title: "",
          data: {},
          errorMessage: {},
          onLoading: false,
        },
      };
    },
    watch: {
      "table.page.current_pages": {
        handler() {
          this.get();
        },
      },
    },
    mounted() {
      this.get();
    },
    methods: {
      async get() {
        this.table.onLoad = true;
  
        try {
          const response = await api(
            this,
            faqService.list(this.table.page.current_pages, { search: this.table.search }),
            false
          );
  
          console.log(response.data.data);
  
          this.table.data = response.data.data;
          this.table.total = response.data.total_items;
          this.table.page = response.data;
        } catch (error) {
          this.table.data = [];
          this.table.total = 0;
        } finally {
          this.table.onLoad = false;
        }
      },
  
      filter() {
        if (this.table.search != this.$route.query.search) {
          clearTimeout(this.table.loadTimeout);
          this.table.loadTimeout = setTimeout(() => {
            if (this.table.search == "") {
              this.$router.push({ query: null });
            } else {
              this.$router.push({ query: { search: this.table.search }, });
            }
  
            this.get();
          }, 500);
        }
      },
      changePage() {
        this.table.onLoad = true;
  
        clearTimeout(this.table.loadTimeout);
        this.table.loadTimeout = setTimeout(() => {
          this.get();
        }, 100);
      },
    },
  };
  </script>
  